<script setup lang="ts">
import { computed } from "vue";

import AvatarGroup from "~/components/dumb/AvatarGroup.vue";
import EntityPreviewTooltip from "~/components/dumb/EntityPreviewTooltip.vue";
import Template from "~/components/dumb/Template.vue";
import Tooltip from "~/components/dumb/Tooltip.vue";
import { EditorMode } from "~/shared/enums";
import type { PropertyUser } from "~/shared/types";
import { useDataStore } from "~/stores";
import { getUserDisplayName } from "~/utils/user";

const props = defineProps<{
  value: string[];
  isMultiple: boolean;
  editorMode: EditorMode;
  property?: PropertyUser;
  unsetLabel?: string;
}>();

const dataStore = useDataStore();
const isBoardMode = computed(() => props.editorMode === EditorMode.BOARD);
const user = computed(() => (props.value.length === 1 ? dataStore.getUserByDuid(props.value[0]) : undefined));
const assigneeLabel = computed(() => {
  if (!user.value || !props.property?.adtl.isNameShown) {
    return undefined;
  }
  return getUserDisplayName(user.value);
});
const previewUserDuid = computed(() => (assigneeLabel.value ? user.value?.duid : undefined));
</script>

<template>
  <component
    :is="isBoardMode ? Tooltip : Template"
    v-if="value.length !== 0"
    :text="isBoardMode ? property?.title : undefined">
    <EntityPreviewTooltip :user-duid="previewUserDuid" block>
      <div
        class="flex h-5 items-center justify-center gap-1 rounded-sm border border-oncolor text-xs text-md"
        :class="isBoardMode && assigneeLabel ? 'pr-1.5 pl-1' : 'px-1'">
        <AvatarGroup
          :duids="value"
          :editor-mode="editorMode"
          :limit="3"
          :first-user-only="!isMultiple"
          small
          :unset-label="unsetLabel"
          :is-tooltip-disabled="Boolean(assigneeLabel)" />

        <span v-if="assigneeLabel" class="truncate" :title="assigneeLabel">
          {{ assigneeLabel }}
        </span>
      </div>
    </EntityPreviewTooltip>
  </component>
</template>
